import Vue from "vue";
import VueRouter from "vue-router";
import redirect from "@/views/redirect/redirect.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/pc",
    name:"pc",
    component:()=>import("@/views/viewRouter/main.vue"),
    children:[{
      path: "buyPb",
      name: "pcBuyPb",
      component: () => import("@/views/pc/buy/buyPb.vue"),
    },{
      path: "buyVip",
      name: "pcBuyVip",
      component: () => import("@/views/pc/buy/buyVip.vue"),
    }, {
      path: "result",
      name: "pcResult",
      component: () => import("@/views/pc/result/result.vue"),
    }, {
      path:"order",
      name:"pcOrder",
      component: () => import("@/views/pc/order/order.vue"),
    },{
      path:"*",
      name:"pcGoto404",
      redirect:"/404"
    }]
  },{
    path: "/phone",
    name:"phone",
    component:()=>import("@/views/viewRouter/main.vue"),
    children:[{
      path: "buyPb",
      name: "phoneBuyPb",
      component: () => import("@/views/phone/buy/buyPb.vue"),
    },{
      path: "buyVip",
      name: "phoneBuyVip",
      component: () => import("@/views/phone/buy/buyVip.vue"),
    }, {
      path: "result",
      name: "phoneResult",
      component: () => import("@/views/phone/result/result.vue"),
    }, {
      path:"order",
      name:"phoneOrder",
      component: () => import("@/views/phone/order/order.vue"),
    },{
      path:"*",
      name:"phoneGoto404",
      redirect:"/404"
    }]
  },{
    path: "/404",
    name:"notFound",
    component:()=>import("@/views/404/notFound.vue")
  },
  {
    path: "/*",
    name:"redirect",
    component:()=>import("@/views/redirect/redirect.vue")
  },

];


const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to,from,next)=>{
//   if(to.matched.length === 1){
//     console.log(to)
//     // from.name ? next({ name:from.name }) : next('/404')
//   }else{
//     next()
//   }
// })

export default router;
